import { AfterViewInit, Directive, ElementRef, HostBinding, HostListener } from "@angular/core";
import { NotificationService } from "@core";
import { SvgIcon } from "src/app/components/responsive-icon/responsive-icon.component";
import { Swipe, watchVerticalSwipeEvents$ } from "@helpers";
import { AppViewVar } from "@model";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

@Directive()
export abstract class AbstractNotificationDirective implements AfterViewInit {
  SvgIcon = SvgIcon;

  @HostBinding("class") class = "notification-instance";

  abstract colorVariable: AppViewVar;

  constructor(
    private _elementRef: ElementRef,
    private _notificationService: NotificationService,
  ) {}

  isExpanded = false;

  @HostListener("click") handleClick() {
    this.slideDown();
  }

  slideUp() {
    this._elementRef.nativeElement.classList.remove("notification-expanded");
    this.isExpanded = false;
  }

  slideDown() {
    this._elementRef.nativeElement.classList.add("notification-expanded");
    this.isExpanded = true;
  }

  close() {
    this._notificationService.closeNotification();
  }

  ngAfterViewInit() {
    watchVerticalSwipeEvents$.pipe(takeUntilDestroyed()).subscribe((event) => {
      if (event === Swipe.UP) {
        // console.log("up");
        this.slideUp();
      }
      if (event === Swipe.DOWN) {
        // console.log("down");
        this.slideDown();
      }
    });
  }
}
